import { useState, useEffect } from 'react';

const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkIsTablet = () => {
      const width = window.innerWidth;
      setIsTablet(width >= 768 && width <= 1024);
    };

    // Comprobar al cargar la página
    checkIsTablet();

    // Añadir un event listener para detectar cambios en el tamaño
    window.addEventListener('resize', checkIsTablet);

    // Limpiar el event listener
    return () => {
      window.removeEventListener('resize', checkIsTablet);
    };
  }, []);

  return isTablet;
};

export default useIsTablet;
